// plugins/api-client.client.js
import APIClient from '~/api/apiClient';

export default defineNuxtPlugin({
  name: 'api-client',
  async setup(nuxtApp) {
    const apiClient = APIClient.getInstance();

    return {
      provide: {
        $api: apiClient,
      },
    }
  }
});
